export { default } from "./ClassLinkIcon";
